import React, {Fragment, useEffect, useState} from 'react';
import {Col, Container, Row} from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import AddApk from "./AddApk";
import ApkTable from "./ApkTable";
import ManageUsers from "../../../../api/ManageUsers";
import ManageAPK from "../../../../api/ManageAPK";

const UsersCardssContain = () => {

    const [apks, setApks] = useState([]);


    function loadApks() {
        ManageAPK.loadApks()
            .then(response => {
                setApks(response.data.data)
            })
            .catch(error => {
                console.error("error ::: ", error)
            })
    }

    useEffect(() => {
        loadApks();
    }, [])

  return (
      <Fragment>
          <Breadcrumbs mainTitle='Gestion des apks' parent='Gestion' title='APK' />
          <Container fluid={true}>
              <div className='edit-profile'>
                  <Row>
                      <Col xl='4'>
                          <AddApk reloadAction={loadApks}/>
                      </Col>
                      <Col md='8'>
                          <ApkTable apks={apks} reloadAction={loadApks}/>
                      </Col>
                  </Row>
              </div>
          </Container>
      </Fragment>
  );
};
export default UsersCardssContain;
